export default "__VITE_ASSET__ByCx99Wi__"